module.exports = __webpack_public_path__ + "img/arrow2.fcef3aa9.svg";